// ============================================================
// CART MIX PREVENTION CONFIG
// Set to false to allow mixing gift and non-gift products
// ============================================================
const CART_MIX_PREVENTION_ENABLED = true;

// Shared toast notification for cart mix errors (used by product-form and quick-add-bulk)
window.showCartMixToast = function(message) {
  const existing = document.getElementById('cart-mix-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 'cart-mix-toast';
  Object.assign(toast.style, {
    position: 'fixed',
    top: '50%',
    right: '20px',
    transform: 'translateY(-50%) translateX(120%)',
    background: '#FFE9E9',
    color: '#DC2626',
    padding: '20px 44px 20px 20px',
    borderRadius: '8px',
    borderLeft: '4px solid #DC2626',
    fontSize: '14px',
    lineHeight: '1.6',
    maxWidth: '360px',
    zIndex: '99999',
    transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    boxShadow: '0 4px 16px rgba(220,38,38,0.12)',
  });

  const text = document.createElement('span');
  text.textContent = message;
  toast.appendChild(text);

  const closeBtn = document.createElement('button');
  closeBtn.textContent = '×';
  Object.assign(closeBtn.style, {
    position: 'absolute',
    top: '12px',
    right: '14px',
    background: 'none',
    border: 'none',
    color: '#DC2626',
    fontSize: '20px',
    lineHeight: '1',
    cursor: 'pointer',
    padding: '0',
  });
  closeBtn.addEventListener('click', dismiss);
  toast.appendChild(closeBtn);

  document.body.appendChild(toast);

  function dismiss() {
    toast.style.transform = 'translateY(-50%) translateX(120%)';
    toast.addEventListener('transitionend', () => toast.remove(), { once: true });
  }

  // Slide in from right
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      toast.style.transform = 'translateY(-50%) translateX(0)';
    });
  });

  setTimeout(dismiss, 6000);
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartType = document.body.dataset.cartType;
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // === CART MIX PREVENTION ===
        const conflictMessage = await this.checkCartMixConflict();
        if (conflictMessage) {
          this.handleErrorMessage(conflictMessage);
          // Card forms have no inline error wrapper — fall back to toast notification
          if (!this.querySelector('.product-form__error-message-wrapper')) {
            window.showCartMixToast(conflictMessage);
          }
          return;
        }
        // === END CART MIX PREVENTION ===

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('wb-quick-view');
            const wbModel = this.closest('wb-modal');
            if(wbModel){
              wbModel?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cartType == "sticky_cart_bar") {
                this.cart.renderContents(response, false);
                document.querySelector(".quick-notify").classList.add("active");  
              } else {
                this.cart.renderContents(response);
              }
            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async checkCartMixConflict() {
        if (!CART_MIX_PREVENTION_ENABLED) return null;

        const isGiftProduct = this.dataset.productGift === 'Yes';

        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();

          if (!cart.items || cart.items.length === 0) return null;

          const cartHasGift = cart.items.some(
            (item) => item.properties?.['_product_gift'] === 'Yes'
          );
          const cartHasNonGift = cart.items.some(
            (item) => item.properties?.['_product_gift'] === 'No'
          );

          if (isGiftProduct && cartHasNonGift) {
            return 'Produk reguler dan hadiah tidak bisa digabung. Mohon kosongkan keranjang Anda terlebih dahulu untuk melanjutkan.';
          }
          if (!isGiftProduct && cartHasGift) {
            return 'Produk reguler dan hadiah tidak bisa digabung. Mohon kosongkan keranjang Anda terlebih dahulu untuk melanjutkan.';
          }

          return null;
        } catch (e) {
          console.error('[CartMix] Failed to check cart:', e);
          return null;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.dataset.clayout == 'card') {
            this.submitButtonText.textContent = window.variantStrings.addToCartCard;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
